import { getDefaultLanguage } from "@lib/helpers/Common";
import { getSystemThemeMode } from "@lib/helpers/ThemeHelper";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface ISettings {
  isDark: boolean;
  sidebar: {
    collapsed: boolean;
  };
  locale: {
    languageId: string;
    locale: string;
    name: string;
    icon?: string;
  };
  themeConfig: null;
}

const initialState: ISettings = {
  isDark: getSystemThemeMode(),
  sidebar: {
    collapsed: true,
  },
  locale: getDefaultLanguage(),
  themeConfig: null,
};

const slice = createSlice({
  name: "settings",
  initialState: initialState,
  reducers: {
    toggleThemeMode: (state, action: PayloadAction<boolean>) => {
      state.themeConfig = null;
      state.isDark = action.payload;
    },
    setToggleSidebar: (state, action: PayloadAction<boolean>) => {
      state.themeConfig = null;
      state.sidebar.collapsed = action.payload;
    },
    setLocale: (state, action: PayloadAction<any>) => {
      state.themeConfig = null;
      state.locale = action.payload;
    },
  },
});

export default slice.reducer;
export const { toggleThemeMode, setToggleSidebar, setLocale } = slice.actions;
